import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useHours } from "../../lib/content";
import { parisNow, isOpenNow, formatSlots } from "../../lib/hours";

export const HoursPanel = ({ testId = "hours-panel" }) => {
  const hours = useHours();
  const [now, setNow] = useState(parisNow);

  useEffect(() => {
    const t = setInterval(() => setNow(parisNow()), 60000);
    return () => clearInterval(t);
  }, []);
  const open = isOpenNow(hours);

  return (
    <div className="rounded-3xl border border-[#D4A359]/20 bg-[#123322]/80 p-6 sm:p-9" data-testid={testId}>
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h3 className="font-display text-2xl sm:text-3xl text-[#F7F4EB] flex items-center gap-3">
          <Clock className="w-6 h-6 text-[#D4A359]" strokeWidth={1.4} /> Horaires
        </h3>
        <span
          data-testid="open-status-badge"
          className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.15em] ${open ? "bg-[#8FAD95]/15 text-[#B9D3BE] border border-[#8FAD95]/40" : "bg-[#C85A32]/15 text-[#F0A385] border border-[#C85A32]/40"}`}
        >
          <span className={`w-2 h-2 rounded-full ${open ? "bg-[#8FAD95] animate-pulse" : "bg-[#C85A32]"}`} />
          {open ? "Ouvert maintenant" : "Fermé actuellement"}
        </span>
      </div>
      {!hours.length && <p className="mt-7 text-sm text-[#A2B3A7]">Horaires en cours de chargement…</p>}
      <ul className="mt-7 divide-y divide-[#D4A359]/10">
        {hours.map((h) => {
          const today = h.day === now.day;
          return (
            <li
              key={h.label}
              data-testid={`hours-row-${h.day}`}
              className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 py-3.5 px-3 -mx-3 rounded-xl transition-colors ${today ? "bg-[#D4A359]/10 ring-1 ring-[#D4A359]/40" : ""}`}
            >
              <span className={`font-medium ${today ? "text-[#E5B66C]" : "text-[#F7F4EB]"}`}>
                {h.label} {today && <span className="ml-2 text-[10px] uppercase tracking-[0.2em] text-[#D4A359]">Aujourd’hui</span>}
              </span>
              <span className={`text-sm sm:text-base ${h.slots.length ? "text-[#D6CFC0]" : "text-[#F0A385]"}`}>{formatSlots(h.slots)}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
